import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'
import LOGO from '../../../../images/logo.svg'
import {NavLink} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileContract, faHandshake, faHeadset, faPlus, faSignOutAlt, faUsers} from "@fortawesome/free-solid-svg-icons";
import {connect} from "react-redux";
import {logoutUser} from "../../../../redux/actions";
import {version} from "../../../../App";
import {Version} from "../../worker/navigation/navigation";
function Navigation (props) {
    const {dispatch} = props;
    return(
        <Wrapper>
            <div>
                <Logo><img src={LOGO}/></Logo>
                <NavLinksWrapper>
                    <Label>Strefa partnera</Label>
                    <StyledNavLink exact to="/panel/otomoto">
                        <FontAwesomeIcon icon={faHandshake}/> Integracja otomoto
                    </StyledNavLink>
                </NavLinksWrapper>
            </div>
            <div>
                <StyledButton onClick={() => dispatch(logoutUser())}>
                    <FontAwesomeIcon icon={faSignOutAlt}/> Wyloguj się
                </StyledButton>
                <Version>
                    v{version}
                </Version>
            </div>
        </Wrapper>
    )
};

Navigation.propTypes = {
};

function mapStateToProps(state) {
    return {
        isLoggingIn: state.auth.isLoggingIn,
        loginError: state.auth.loginError,
        isAuthenticated: state.auth.isAuthenticated
    };
}
export default connect(mapStateToProps)(Navigation);


const Label = styled.label`
  width: 100%;
  background: rgba(0,0,0,0);
  padding: 3px 20px;
  color: ${({theme}) => theme.thirdColor};
  font-size: ${({theme}) => theme.font.XS};
  margin-bottom: 10px;
  display: block;
  text-transform: uppercase;
  font-weight: ${({theme}) => theme.font.Bold};
`;

const StyledButton = styled.button`
  display: block;
  width: 90%;
  margin: 0 auto;
  padding: 8px;
  padding-left: 20px;
  border-radius: 5px;
  // background: ${({theme}) => theme.primaryBackground};
  color: ${({theme}) => theme.thirdColor};
  font-size: ${({theme}) => theme.font.M};
  font-weight: ${({theme}) => theme.font.Regular};
  position: relative;
  margin-bottom: 10px;
  transition: all 0.3s;
  cursor: pointer;
  background: none;
  border: none;
  text-align: left;
  
  svg{
    min-width: 25px;
    margin-right: 10px;
  }
`;

const StyledNavLink = styled(NavLink)`
  display: block;
  width: 90%;
  margin: 0 auto;
  padding: 8px;
  padding-left: 20px;
  border-radius: 5px;
  // background: ${({theme}) => theme.primaryBackground};
  color: ${({theme}) => theme.thirdColor};
  font-size: ${({theme}) => theme.font.M};
  font-weight: ${({theme}) => theme.font.Regular};
  position: relative;
  margin-bottom: 10px;
  transition: all 0.3s;
  cursor: pointer;
  
  svg{
    min-width: 25px;
    margin-right: 10px;
  }
  a{
    font-size: 13px;
    background: ${({theme}) => theme.primaryColor};
    color: white;
    display: block;
    height: 22px;
    width: 25px;
    float: right;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    
    svg{
    width: 13px;
    height: 13px;
    margin: 0px;
    }
  }
  &:hover{
     color:${({theme}) => theme.secondColor};
  }
  
  &.active{
    background: ${({theme}) => theme.primaryBackground};
    color:${({theme}) => theme.primaryColor};
  }
  
`;

const NavLinksWrapper = styled.div`

`;

const Logo = styled.div`
  margin-top: 40px;
  padding: 0 20px;
  margin-bottom: 40px;
  img{
    max-height: 70px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Wrapper = styled.div`
  background: white;
  height: 100%;
  min-width: 300px;
  max-width: 300px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding-bottom: 20px;
`;
